// extracted by mini-css-extract-plugin
export default {"descriptions":"AppInfo_descriptions__Jofzc","tags":"AppInfo_tags__Zi-0U","tag":"AppInfo_tag__MzaXo"};